"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalizedCartTotals = void 0;
const tslib_1 = require("tslib");
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(require("../../store"));
/**
 * Localized a cart line totals
 * @param {*} passedProps
 * @returns
 */
const useLocalizedCartTotals = () => {
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedCartTotals),
    };
};
exports.useLocalizedCartTotals = useLocalizedCartTotals;
//# sourceMappingURL=useLocalizedCartTotals.js.map